import { types, isType } from "mobx-state-tree"
import { getAllTeams, getSingleTeam } from "../api-calls/teams"
import { type } from "os";
import { Team } from '../models/Team';

const TeamStoreModel = types
    .model('TeamStore', {
        loading: types.boolean,
        loaded: types.boolean,
        teams: types.map(Team),
        team: types.map(Team),
    })
    .views(self => {
        return {
            isLoaded: () => self.loaded,
            isLoading: () => self.loading,
            getTeams: () => self.teams.values(),
            getTeamsCount: () => self.teams.size,
            getTeamById: (team_id) => self.teams.get(team_id),
        }
    })
    .actions(self => {
        return {
            queryTeams: async () => {
                self.loading = true;
                self.loaded = false;
                getAllTeams().then((teams) => {
                    self.setTeams(teams);
                    self.setLoading(false);
                    self.setLoaded(true);
                });
                return self.teams;
            },
            setTeams: (teams) => {
                for (let team of teams) {
                    self.teams.put(team);
                }
            },
            querySingleTeam: async (teamId) => {
                self.resetSingleTeam();
                getSingleTeam(teamId).then((team) => {
                    self.setTeam(team);
                });
                return self.team;
            },
            setTeam: (teams) => {
                    self.team.put(teams);
            },
            setLoading: (loading) => {
                self.loading = loading;
            },
            setLoaded: (loaded) => {
                self.loaded = loaded;
            },
            resetSingleTeam: (loaded) => {
                self.team = {};
            }
        }
    });

const TeamStore = TeamStoreModel.create({
    loaded: false,
    loading: false,
    teams: {},
    team: {}
});

export default TeamStore;


// WEBPACK FOOTER //
// ./src/stores/TeamStore.js